// UI version displayed in the footer.
// Edit this file to bump the UI version manually.
export const UI_VERSION = "1.0.1.0002";
